export default __webpack_public_path__ + "static/skatert_new-cf4e3738e383e8d64a03610bf95d0ba3.jpg";